import { PRESETS, CHANNEL_META } from "./statsUtils";
import { DatePicker } from "@/components/ui/date-picker";

const Sel = ({ value, onChange, children, testId, label }) => (
  <label className="flex min-w-0 flex-col gap-1">
    <span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">{label}</span>
    <select className="rw-input h-9 min-w-0 py-0 text-sm" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId}>
      {children}
    </select>
  </label>
);

const nm = (v) => (typeof v === "object" && v ? v.hr || v.en || Object.values(v)[0] : v) || "";

export function StatsFilters({ f, set, properties, roomTypes, units }) {
  const rts = roomTypes.filter((r) => !f.property_id || r.property_id === f.property_id);
  const us = units.filter((u) => (!f.property_id || u.property_id === f.property_id) && (!f.room_type_id || u.room_type_id === f.room_type_id));
  return (
    <div className="rw-card space-y-3 p-3 sm:p-4" data-testid="stats-filters">
      <div className="-mx-1 flex gap-1 overflow-x-auto px-1 pb-1" data-testid="stats-presets">
        {PRESETS.map((p) => (
          <button
            key={p.id}
            type="button"
            onClick={() => set({ preset: p.id })}
            className={`shrink-0 whitespace-nowrap rounded-full border px-3 py-1.5 text-xs font-medium transition-colors duration-150 ${f.preset === p.id ? "border-primary bg-primary text-primary-foreground" : "border-border bg-card text-foreground hover:bg-muted"}`}
            data-testid={`stats-preset-${p.id}`}
          >
            {p.label}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-6">
        {f.preset === "custom" && (
          <>
            <label className="flex flex-col gap-1">
              <span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">Od</span>
              <DatePicker value={f.from} onChange={(v) => v && set({ from: v })} clearable={false} className="h-9" data-testid="stats-from" />
            </label>
            <label className="flex flex-col gap-1">
              <span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">Do</span>
              <DatePicker value={f.to} onChange={(v) => v && set({ to: v })} clearable={false} className="h-9" data-testid="stats-to" />
            </label>
          </>
        )}
        <Sel label="Objekt" value={f.property_id} onChange={(v) => set({ property_id: v, room_type_id: "", unit_id: "" })} testId="stats-property">
          <option value="">Svi objekti</option>
          {properties.map((p) => <option key={p.id} value={p.id}>{nm(p.name)}</option>)}
        </Sel>
        <Sel label="Tip smještaja" value={f.room_type_id} onChange={(v) => set({ room_type_id: v, unit_id: "" })} testId="stats-room-type">
          <option value="">Svi tipovi</option>
          {rts.map((r) => <option key={r.id} value={r.id}>{nm(r.name)}</option>)}
        </Sel>
        <Sel label="Jedinica" value={f.unit_id} onChange={(v) => set({ unit_id: v })} testId="stats-unit">
          <option value="">Sve jedinice</option>
          {us.map((u) => <option key={u.id} value={u.id}>{u.code || nm(u.name)}</option>)}
        </Sel>
        <Sel label="Kanal" value={f.channel} onChange={(v) => set({ channel: v })} testId="stats-channel">
          <option value="">Svi kanali</option>
          {Object.entries(CHANNEL_META).map(([k, m]) => <option key={k} value={k}>{m.label}</option>)}
        </Sel>
        <Sel label="Računaj po" value={f.basis} onChange={(v) => set({ basis: v })} testId="stats-basis">
          <option value="stay">Datumu boravka</option>
          <option value="booking">Datumu rezervacije</option>
        </Sel>
        <Sel label="Prihod" value={f.revenue_mode} onChange={(v) => set({ revenue_mode: v })} testId="stats-revenue-mode">
          <option value="gross">Bruto (ukupni iznos)</option>
          <option value="net">Neto (bez OTA provizije)</option>
        </Sel>
      </div>
    </div>
  );
}
